import { useCallback, useMemo, useState } from "react";
import type { ReactNode } from "react";

import { ModeContext } from "@/shared/api";
import type { ModeApi } from "@/shared/api";
import { readMode, writeMode } from "@/shared/config";
import type { AppMode } from "@/shared/config";

/**
 * Режим приложения (доработки §3).
 *
 * Стоит ВНУТРИ QueryProvider и СНАРУЖИ роутера: роуты выбирают экран по
 * режиму, и переключение обязано перерисовать дерево без навигации.
 *
 * Кэш при переключении не сбрасывается намеренно: демо-запросы лежат в
 * собственной ветке ключей (`qk.demo*`), поэтому виртуальный баланс не
 * перетирает реальный. Возврат в реальный режим показывает уже загруженное,
 * а не пустой экран и лишний запрос из общей на весь IP корзины лимита.
 */
export function ModeProvider({ children }: { children: ReactNode }) {
  const [mode, setStored] = useState<AppMode>(readMode);

  const setMode = useCallback((next: AppMode) => {
    writeMode(next);
    setStored(next);
  }, []);

  const value = useMemo<ModeApi>(
    () => ({ mode, isDemo: mode === "demo", setMode }),
    [mode, setMode],
  );

  return <ModeContext value={value}>{children}</ModeContext>;
}
